"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("../style.css"));
var _arrowUp = _interopRequireDefault(require("cccisd-icons/arrow-up8"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down8"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus3"));
var _InlineWysiwyg = _interopRequireDefault(require("../InlineWysiwyg"));
var _ObjectivesList = _interopRequireDefault(require("./ObjectivesList"));
var _SectionTitle = _interopRequireDefault(require("../SectionTitle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LearningObjectives = function LearningObjectives(_ref) {
  var formProps = _ref.formProps;
  var sections = formProps.values.courseDescription.learningObjectives.sections;
  var setLearningObjectiveSections = function setLearningObjectiveSections(learningObjectiveSections) {
    // Need to deep copy to force formProps.dirty and a re-render
    formProps.setValues(_objectSpread(_objectSpread({}, formProps.values), {}, {
      courseDescription: _objectSpread(_objectSpread({}, formProps.values.courseDescription), {}, {
        learningObjectives: _objectSpread(_objectSpread({}, formProps.values.courseDescription.learningObjectives), {}, {
          sections: learningObjectiveSections
        })
      })
    }));
  };
  var onClickSlide = function onClickSlide(index, direction) {
    var updatedSections = _toConsumableArray(sections);
    if (direction === 'up') {
      var temp = updatedSections[index - 1];
      updatedSections[index - 1] = updatedSections[index];
      updatedSections[index] = temp;
    } else if (direction === 'down') {
      var _temp = updatedSections[index + 1];
      updatedSections[index + 1] = updatedSections[index];
      updatedSections[index] = _temp;
    } else {
      console.error("onClickSlide should be passed a direction of 'up' or 'down'");
    }
    setLearningObjectiveSections(updatedSections);
  };
  var onClickAddSection = function onClickAddSection() {
    var learningObjectiveSections = _toConsumableArray(sections);
    var highestKey = 0;
    learningObjectiveSections.forEach(function (section) {
      if (section.key > highestKey) {
        highestKey = section.key;
      }
    });
    learningObjectiveSections.push({
      heading: '',
      statement: '',
      objectives: [],
      key: highestKey + 1
    });
    setLearningObjectiveSections(learningObjectiveSections);
  };
  var onClickDeleteSection = function onClickDeleteSection(index) {
    var updatedSections = sections.filter(function (section, i) {
      return i !== index;
    });
    setLearningObjectiveSections(updatedSections);
  };
  return /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: _style["default"].fieldset
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: _style["default"].fieldsetHeading
  }, "Learning Objectives"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_SectionTitle["default"], {
    name: "learningObjectives",
    placeholder: "Learning Objectives"
  }), sections.map(function (section, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "learning-objectives-section-".concat(section.key),
      className: "".concat(_style["default"].dragContainer, " ").concat(_style["default"].learningObjectivesSection)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].dragAndDropContent
    }, sections.length > 1 && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].learningObjectiveButtons
    }, index > 0 && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-secondary",
      onClick: function onClick() {
        return onClickSlide(index, 'up');
      }
    }, /*#__PURE__*/_react["default"].createElement(_arrowUp["default"], null), " Slide Up"), index < sections.length - 1 && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-secondary",
      onClick: function onClick() {
        return onClickSlide(index, 'down');
      }
    }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null), " Slide Down"), /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-secondary",
      onClick: function onClick() {
        return onClickDeleteSection(index);
      }
    }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null), " Delete")), /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
      name: "courseDescription.learningObjectives.sections[".concat(index, "].heading"),
      label: "Heading"
    }), /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
      name: "courseDescription.learningObjectives.sections[".concat(index, "].statement"),
      label: "Statement"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "mb-3"
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label"
    }, "Objectives"), /*#__PURE__*/_react["default"].createElement(_ObjectivesList["default"], {
      formProps: formProps,
      section: section,
      sectionIndex: index,
      setLearningObjectiveSections: setLearningObjectiveSections
    }))));
  }), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onClickAddSection,
    type: "button",
    className: "btn btn-secondary ".concat(_style["default"].addSectionButton)
  }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null), " Add Learning Objective Section")));
};
var _default = exports["default"] = LearningObjectives;